var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentManager(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "glyphicons-basic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "142px",
    height: "142px",
    viewBox: "56 0 142 142",
    enableBackground: "new 56 0 142 142",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "clipboard",
    fill: "#00AEEF",
    d: "M154.125,82.094v4.438c0,1.226-0.993,2.219-2.219,2.219h-48.813 c-1.226,0-2.219-0.993-2.219-2.219v-4.438c0-1.226,0.993-2.219,2.219-2.219h48.813C153.132,79.875,154.125,80.868,154.125,82.094z  M151.906,97.625h-48.813c-1.226,0-2.219,0.993-2.219,2.219v4.438c0,1.226,0.993,2.219,2.219,2.219h48.813 c1.226,0,2.219-0.993,2.219-2.219v-4.438C154.125,98.618,153.132,97.625,151.906,97.625z M151.906,62.125h-48.813 c-1.226,0-2.219,0.993-2.219,2.219v4.438c0,1.226,0.993,2.219,2.219,2.219h48.813c1.226,0,2.219-0.993,2.219-2.219v-4.438 C154.125,63.118,153.132,62.125,151.906,62.125z M171.875,44.375v71c-0.006,4.899-3.976,8.869-8.875,8.875H92 c-4.899-0.006-8.87-3.976-8.875-8.875v-71c0.005-4.899,3.976-8.87,8.875-8.875h8.875v-4.438c0-2.451,1.987-4.438,4.438-4.438h8.875 c0-4.901,3.974-8.875,8.875-8.875h8.875c4.901,0,8.875,3.974,8.875,8.875h8.875c2.451,0,4.438,1.987,4.438,4.438V35.5H163 C167.899,35.505,171.869,39.476,171.875,44.375z M163.004,115.375l-0.004-71h-8.875v4.438c0,2.451-1.986,4.438-4.438,4.438h-44.375 c-2.451,0-4.438-1.987-4.438-4.438v-4.438H92v71H163.004z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentManager);
export default __webpack_public_path__ + "static/media/content_manager.355936cfe24ef45aa413169ac8ea9c0c.svg";
export { ForwardRef as ReactComponent };